import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import moment from "moment";
import SvgImage from "../../Icons/Icons";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { addFleet } from "../../../services/Store/Actions/fleetActions";
//import { useNavigate } from "react-router-dom";
import { storeMedia, updateProfileAction } from "../../../services/Store/Actions/appActions";



const PhotoUpload=(props)=>{

    const {setFieldValue, values}= props;
    const dispatch= useDispatch();
    const [imageLoader,setImageLoader] = useState(false)
    return(<input
        type="file"
        accept="image/*"
        className="adding-btn"
        onChange={(e) => {
          //alert("hey");
          const img = e?.target.files[0];
          console.log("image", img?.name);
          // e.preventDefault();
          const tempArray = Object.assign([], values.docs);
          if (img == null) {
            //clear image
            setFieldValue("userImage", "", true);
            //for now  only one supported
          } else {
            console.log("upload", {
              img: img,
              uploadType: "aadharFront",
              isRes: true,
            });
            // e.preventDefault();
            // e.setSubmitting(false);
            // e.preventDefault();
            dispatch(
              storeMedia(
                {
                  img: img,
                  uploadType: "aadharFront",
                  isRes: false,
                },
                (res) => {
                  if (res?.url) {
                    console.log("opt", res);
                    tempArray.push(res?.data?.Location);
                    console.log("opt1", tempArray);
                    //setFieldValue("urlBack", res?.url, true);
                    setFieldValue(
                      "userImage",
                      res?.data?.Location,
                      true
                    );
                    // setFieldValue('docs', tempArray, true);
                    //for now  only one supported
                    //setFieldValue("docs", tempArray, true);
                  }
                }
              )
            );
            // setFieldValue("amount", values.amount, true);
          }
        }}
      />);
}


export default PhotoUpload;